import React, { useState, useEffect } from 'react'
import { Box, Button, IconButton, Modal, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import GrassOutlinedIcon from '@mui/icons-material/GrassOutlined';
import { getCsvForAllScans } from '../utils/api';
import CircularLoadingPopUp from './CircularLoadingPopUp';
import { exportToCSVForAllScans } from '../utils/common';

const ACCENT_BLUE = '#22638f';
const TEXT_MUTED = '#93a0b5';
const TEXT_BODY = '#3b4a63';
const BORDER = '#eef2f8';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 420,
    bgcolor: '#fff',
    borderRadius: '14px',
    boxShadow: '0 8px 32px rgba(12, 61, 110, 0.14)',
    p: 0,
};

const cropRowSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    textTransform: 'none',
    backgroundColor: 'rgba(34, 93, 153, 0.05)',
    border: `1px solid rgba(34, 93, 153, 0.12)`,
    borderRadius: '10px',
    padding: '14px 16px',
    marginBottom: '10px',
    '&:hover': {
        backgroundColor: 'rgba(34, 93, 153, 0.1)',
        borderColor: ACCENT_BLUE,
    },
};

function ExportCsvPopUp({ open, setOpen, allScansList, selectedRowData }) {
    const [selectedScanData, setSelectedScanData] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        (async () => {
            try {
                const newOutput = {};
                allScansList.forEach(item => {
                    if (selectedRowData.some(selectedItem => selectedItem.scan_id === item.scan_id)) {
                        if (!newOutput[item.crop_details.crop_name]) {
                            newOutput[item.crop_details.crop_name] = [];
                        }
                        newOutput[item.crop_details.crop_name].push({
                            scan_id: item.scan_id,
                            sub_scan_id: item.sub_scan_id
                        });
                    }
                });
                setSelectedScanData(newOutput);
            } catch (error) {
                console.error(error);
            }
        })()
    }, [allScansList, selectedRowData]);

    const getCsvFile = async (crop_name, crop_scan_list) => {
        try {
            setLoading(true);
            const path = window.location.pathname;
            const userId = path.split("/").pop();
            const response = await getCsvForAllScans(crop_scan_list, userId, crop_name);
            if (response?.data?.data) {
                await exportToCSVForAllScans(response.data.data.scans, response.data.data.user_data, crop_name);
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }


    const handleClose = () => { setOpen(!open) }
    const cropNames = Object.keys(selectedScanData);

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
            >
                <Box sx={style}>
                    <Box
                        sx={{
                            padding: '18px 24px',
                            borderBottom: `1px solid ${BORDER}`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Box>
                            <Typography sx={{ fontSize: 16, fontWeight: 700, color: TEXT_BODY }}>
                                Crop wise CSV download
                            </Typography>
                            <Typography sx={{ fontSize: 12, color: TEXT_MUTED, mt: 0.3 }}>
                                {cropNames.length} crop{cropNames.length !== 1 ? 's' : ''} in selection
                            </Typography>
                        </Box>
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            size="small"
                            sx={{ color: TEXT_MUTED }}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>

                    <Box sx={{ padding: '20px 24px 24px' }}>
                        {loading ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                                <CircularLoadingPopUp />
                            </Box>
                        ) : cropNames.length === 0 ? (
                            <Typography sx={{ fontSize: 13, color: TEXT_MUTED, textAlign: 'center', py: 3 }}>
                                No scans selected.
                            </Typography>
                        ) : (
                            <Box>
                                {cropNames.map(item => (
                                    <Button
                                        key={item}
                                        sx={cropRowSx}
                                        onClick={() => getCsvFile(item, selectedScanData[item])}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            <Box
                                                sx={{
                                                    width: 36, height: 36, borderRadius: '9px',
                                                    backgroundColor: ACCENT_BLUE,
                                                    color: '#fff',
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <GrassOutlinedIcon sx={{ fontSize: 19 }} />
                                            </Box>
                                            <Box sx={{ textAlign: 'left' }}>
                                                <Typography sx={{ fontSize: 15, fontWeight: 800, color: TEXT_BODY, lineHeight: 1.2 }}>
                                                    {item}
                                                </Typography>
                                                <Typography sx={{ fontSize: 11.5, fontWeight: 600, color: TEXT_MUTED }}>
                                                    {selectedScanData[item].length} scan{selectedScanData[item].length !== 1 ? 's' : ''}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box
                                            sx={{
                                                width: 34, height: 34, borderRadius: '8px',
                                                backgroundColor: '#fff',
                                                border: `1px solid rgba(34, 93, 153, 0.2)`,
                                                color: ACCENT_BLUE,
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                flexShrink: 0,
                                            }}
                                        >
                                            <DownloadOutlinedIcon sx={{ fontSize: 17 }} />
                                        </Box>
                                    </Button>
                                ))}
                            </Box>
                        )}
                    </Box>
                </Box>
            </Modal>
        </div>
    )
}

export default ExportCsvPopUp